export const LEGAL_GENERAL_AND_MANDATORY_INFO: string = `

### <!--= ++sectionIndex -->. General and Mandatory Information

#### <!--= sectionIndex -->.1. Data Protection

The operators of these pages take the protection of your personal data very seriously. We treat your personal data as confidential and in accordance with the statutory data protection regulations and this privacy policy.

When you use this website, various personal data will be collected. Personal data are data with which you could be personally identified. This privacy policy explains what data we collect and what we use it for. It also explains how and for what purpose this happens.

Please note that data transmitted via the internet (e.g., via email communication) may be subject to security breaches. Complete protection of your data from third-party access is not possible.

#### <!--= sectionIndex -->.2. Information about the Data Controller

The party responsible for processing data on this website is:

<!-- for (const addressLine of company.address) { --><!--= addressLine --><br><!-- } -->

Phone / WhatsApp Business: <!--= company.phone -->
Email: <!--= company.mail -->

The responsible party is the natural or legal person who alone or jointly with others decides on the purposes and means of processing personal data (names, email addresses, etc.).

#### <!--= sectionIndex -->.3. Revocation of Your Consent to Data Processing

Many data processing operations are only possible with your express consent. You may revoke your consent at any time with future effect. An informal email making this request is sufficient. The data processed before we receive your request may still be legally processed.

#### <!--= sectionIndex -->.4. Right to Complaint with the Supervisory Authority

In the case of violations of data protection law, the person affected has the right of appeal to the competent supervisory authority. The competent supervisory authority for matters related to data protection legislation is the data protection officer of the German state in which our company is headquartered.

A list of data protection officers and their contact details can be found at the following link: [BFDI Germany](https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html)

#### <!--= sectionIndex -->.5. Right to Data Portability

You have the right to have data which we process based on your consent or in fulfillment of a contract automatically delivered to yourself or to a third party in a standard, machine-readable format. If you require the direct transfer of data to another responsible party, this will only be done to the extent technically feasible.

#### <!--= sectionIndex -->.6. Information, Blocking, Deletion

As permitted by law, you have the right to be provided at any time with information free of charge about any of your personal data that is stored as well as its origin, the recipient and the purpose for which it has been processed. You also have the right to have this data corrected, blocked or deleted. You can contact us at any time using the address given in our legal notice if you have further questions on the topic of personal data.

#### <!--= sectionIndex -->.7. Objection to Promotional Emails

We hereby expressly prohibit the use of contact data published in the context of website legal notice requirements with regard to sending promotional and informational materials not expressly requested. The website operator reserves the right to take specific legal action if unsolicited advertising material, such as email spam, is received.
`;
